import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"; 
import { LANDING_TYPE_CONTENT } from "../interfaces";
import { getID } from "src/libs/utilities";

export default function header(): any[] {
    return [
        {
          "id": getID("header"),
          "type": LANDING_TYPE_CONTENT.HEADER, 
          "height": 100,
          "logo": {
            "animated": ANIMATED_STYLE.FADE_IN_RIGHT,
            "animated_delay": 1,
            "src": "/assets/img/landing/examples/brandlogo1.svg",
            "link_url": "/",
            "width": 180,
            "style": { "padding": 10 }
          }, 
          "menu": {
            "id": getID("menu"),
            "className": "text-uppercase small",
            "design_type": "inline",
            "animated_delay": ANIMATE_DELAY.WATERFALL,
            "animated": ANIMATED_STYLE.FADE_IN_LEFT,
            "items": [
              {
                "id": getID("menu"),
                "route": "#section-411",
                "title": "Образовательные организации, представленные на Мероприятии.",
                "icon": "fas fa-tools",
                "children": [
                  {
                    "id": getID("menu"),
                    "route": "fest/7",
                    "title": "Жизненный проект. 11 класс",
                    "icon": "fas fa-server"
                  },
                  {
                    "id": getID("menu"),
                    "route": "#section-10-1qq",
                    "title": "Мои маршруты",
                    "icon": "fas fa-server"
                  }
                ]
              },
              {
                "id": getID("menu"),
                "route": "fest/7",
                "title": "Жизненный проект. 11 класс",
                "icon": "fas fa-faucet"
              },
              {
                "id": getID("menu"),
                "route": "#section-10-1qq",
                "title": "Мои маршруты",
                "icon": "fas fa-socks"
              }
            ]
          },
          "contacts": {
            "animated": ANIMATED_STYLE.FADE_IN_RIGHT,
            "animated_delay": ANIMATE_DELAY.WATERFALL,
            "items": [
              {
                id: getID("contact"),
                "label": "Связаться",
                "url": "",
                "sc": "telegram",
                "type": "small_outline",
                "cf": { "contactFormSectionID": "-1" }
              }
            ]
          },
          "isOvertopSwicth": true, 
          "overtopMenu": {
            "id": "menu-bbf61eaa-689",
            "className": "text-uppercase small text-light",
            "style": {
                "color": "#c9e0ff"
            }
          },
          "overtopStyle": {
             "backgroundColor": "#293347"   
          },
          defaultTitle: "Шапка страницы с меню",
          defaultDescription: "Логотип, меню, контакты в одну строку",
        },
        {
          "id": getID("header"),
          "type": LANDING_TYPE_CONTENT.HEADER,
          "isOvertopSwicth": true,
          "overtopClassName": "bg-warn", 
          "vertical": true,
          "logo": {
            "animated": ANIMATED_STYLE.FADE_IN_RIGHT,
            "animated_delay": 1,
            "src": "/assets/img/landing/examples/logo_kraefest_full.svg",
            "link_url": "https://ya.ru/",
            "width": 180,
            "style": { "padding": 10 }
          },
          "menu": {
            "id":  getID("menu"),
            "className": "text-uppercase small",
            "design_type": "inline",
            "animated_delay": ANIMATE_DELAY.WATERFALL,
            "animated": ANIMATED_STYLE.FADE_IN_LEFT,
            "items": [
              {
                "id":  getID("menu"),
                "route": "#section-411",
                "title": "Образовательные организации, представленные на Мероприятии.",
                "icon": "fas fa-tools",
                "children": [
                  {
                    "id":  getID("menu"),
                    "route": "fest/7",
                    "title": "Жизненный проект. 11 класс",
                    "icon": "fas fa-server"
                  },
                  {
                    "id":  getID("menu"),
                    "route": "#section-10-1qq",
                    "title": "Мои маршруты",
                    "icon": "fas fa-server"
                  }
                ]
              },
              {
                "id":  getID("menu"),
                "route": "fest/7",
                "title": "Жизненный проект. 11 класс",
                "icon": "fas fa-faucet"
              },
              {
                "id":  getID("menu"),
                "route": "#section-10-1qq",
                "title": "Мои маршруты",
                "icon": "fas fa-socks"
              }
            ]
          },
          "contacts": {
            "animated": ANIMATED_STYLE.FADE_IN_RIGHT,
            "animated_delay": ANIMATE_DELAY.WATERFALL,
            "items": [
              {
                id: getID("contact"), 
                "url": "",
                "sc": "telegram",
                "type": "small_outline",
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "vk",
                "type": "small_outline",
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "odnoklassniki",
                "type": "small_outline",
                "cf": { "contactFormSectionID": "-1" }
              }, 
              {
                id: getID("contact"), 
                "url": "",
                "sc": "dzen",
                "type": "small_outline",
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "rutube",
                "type": "small_outline",
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "max",
                "type": "small_outline",
                "cf": { "contactFormSectionID": "-1" }
              },
            ]
          },
          defaultTitle: "Шапка страницы с меню",
          defaultDescription: "Логотип, меню, контакты в колонку",
        },
    ]
}